import React, { useEffect, useRef, useState } from "react";
import store from "../../../redux/store";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Constants from "../../../Constants";
import { confirmAlert } from "react-confirm-alert";
import { useSelector } from "react-redux";
import { redirect, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ConditionalBlock } from "../../../ConditionalBlock";
import { updateReviewWorkflow,updateAutomaticTmSyncState } from "../../../redux/reducers/ReviewWorkFlowSlice";
import $ from "jquery";
import {
  getAxiosResponse,putAxiosResponse,
  deleteAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import jQuery from "jquery";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { ActivateIconWorkflow, DeactivateIconWorkflow, DeleteIconBold, EditIconBold, MinusCircleIcon, PlusCircleIcon } from "../../../AppIcons";
export default function ReviewWorkflow() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const [activeWorkflow, setActiveWorkflow] = useState([]);
  const [inactiveWorkflow, setInActiveWorkflow] = useState([]);
  const [showAddNewButton,setShowAddNewButton] = useState(false)
  const [dataLoadedCount,setDataLoadedCount] = useState(20)
  const [deactivateError,setDeactivateError] = useState('')
  const [allDepartments,setAlldepartments] = useState([])
  const translate = t;
  const navigate = useNavigate();
  var acc = document.getElementsByClassName("accordion-heading");
  const [active, showActive] = useState(true);
  const [inactive, showInActive] = useState(false);
  const dispatch = useDispatch();

  const redirect = (phase) => {
    dispatch(updateReviewWorkflow(phase));
    navigate(`/settings/workflow/${phase.id}`);
  };
  const options = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const redirectInactive = (phase) => {
    dispatch(updateReviewWorkflow(phase));
    navigate(`/settings/disable-workflow/${phase.id}`);
  };
  
  const confirmDelete = (id) => {
    let confirmClicked = false;
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteTemplate"
        });
        $("h1").attr({
        'id': 'deleteTemplate',
       });
      }, 200);
      setTimeout(() => {
        $('#confirmDelete').trigger('focus');
      }, 500);
    confirmAlert({
      title: "Confirm Delete",
      message: (
        <p>
          Click Yes to delete . Upon deletion, users will no longer be able to
          create new projects with this workflow. This action cannot be undone.
        </p>
      ),
      buttons: [
        {
          id: "confirmDelete",
          label: "Yes",
          onClick: () =>{
            deleteAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(id)).then((res) => {
              setDeactivateError(res?.data?.data?.body?.success?"":"error")
              getWorkflowData();
            });
            confirmClicked = true;
          },
            onKeyDown : (e) => {
              if(e.key === Constants.TAB && e.shiftKey === true){
                e.preventDefault()
                $('#cancelDelete').trigger('focus');
              }
            }
        },
        {
          id: "cancelDelete",
          label: "No",
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              e.preventDefault()
              $('#confirmDelete').trigger('focus');
            }
          }
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      // keyCodeForClose: [8, 32],
      // willUnmount: () => {},
      afterClose: () => {
        if (confirmClicked) {
          $('.lastdisable').trigger('focus');
          return;
        } else {
          $('.delFocus').trigger("focus");
          $('.delFocus').removeClass("delFocus");
        }
      },
      // onClickOutside: () => {},
      // onKeypress: () => {},
      // onKeypressEscape: () => {},
      overlayClassName: "delete_overlay",
    });
  };
  const getWorkflowData = async() => {
    var activeCount = null
    var inActiveCount = null
    const activeData = await getAxiosResponse(APIUrls.GET_WORKFLOW_BY_STATUS("ACTIVE"))
        if (activeData) {
          activeCount = activeData?.data?.data?.length
          setActiveWorkflow(activeData?.data?.data);
        }
    const inActiveData = await getAxiosResponse(APIUrls.GET_WORKFLOW_BY_STATUS("INACTIVE"))
        if (inActiveData) {
          inActiveCount = inActiveData.data.data.length
          setInActiveWorkflow(inActiveData.data.data);
        }
      if(activeCount !== null && inActiveCount !== null){
        var totalCount = activeCount+inActiveCount
        setDataLoadedCount(totalCount)
      }
  };
  const editWorkflowStatus =(id,name,status)=>{
    var statusText = status === 'ACTIVE' ? 'activate'  :  'deactivate'
    var payload = {
      "id": id,
      "status": status
  }
    confirmAlert({
      title: status === 'ACTIVE' ? `${statusText.charAt(0).toUpperCase()+ statusText.slice(1)} ${name}` :  `${statusText.charAt(0).toUpperCase()+ statusText.slice(1)} ${name}`,
      message : (<p>{`Click accept to ${statusText} ${name}  for my organization. Upon deactivation,
       users will no longer be able to create new projects with this workflow.`}</p>),
      buttons: [
        {
          label: "Accept",
          onClick: () =>{
            putAxiosResponse(APIUrls.WORKFLOW_STATUS_CHANGE(id),payload).then((res) => {
              if(res.data.data && res.data.data.body && !res.data.data.body.success){
                setDeactivateError(res.data.data.body.success.errors)
              }
              else{
                getWorkflowData();
              }
              
            });
          },
            onKeyDown : (e) => {
              if(e.key === Constants.TAB && e.shiftKey === true){
                e.preventDefault()
                $('#cancelDelete').trigger('focus');
              }
            }
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      
      overlayClassName: "delete_overlay",
    });
  }
  const departActive = () =>{
    if(options?.features?.USER_GROUPS && allDepartments) {
      if(allDepartments.length > 1 || (allDepartments.length === 1 && allDepartments[0].id !== options.systemUserGroup.id)) {
        return true;
      }
    }
  return false;
  }
  useEffect(() => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => { 
        setAlldepartments(res.data.data)
      })
    
    getWorkflowData();
    $(".lastdisable").trigger("focus");
  }, []);

  useEffect(()=>{
    if(dataLoadedCount === 20){
      setShowAddNewButton(false)
    }else if(dataLoadedCount < 20){
      setShowAddNewButton(true)
    }
    
  },[dataLoadedCount])
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Review workflow template', url:''},
  ];
  const enabledWorkflowKeydown = (event) => {
    if (event.key===Constants.ENTER) {
      showActive(!active);
    }
  }
  const disabledWorkflowKeydown = (event) => {
    if (event.key===Constants.ENTER) {
      showInActive(!inactive);
    }
  }
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading flex justify-center">
                <div className="flex-left">
                  <div className="back-arrow flex-center">
                    <button aria-label="Back to Settings" onClick={() => navigate("/settings")}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                      >
                        <path
                          d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </button>
                    <span>Back to Settings</span>
                  </div>
                  <h3 className="flex">Review Workflow Templates</h3>
                  <ConditionalBlock condition={options.features !== undefined && departActive()}>
                  <span>
                    Set up your review workflow templates and choose which
                    templates will be used by each department. You can have 20
                    templates at a time.
                  </span>
                  </ConditionalBlock>
                  <ConditionalBlock condition={options.features !== undefined && !departActive()}>
                  <span>
                  Set up your review workflow templates. Deactivate templates to stop having them available when creating a new project. You can have 20 templates at a time.
                  </span>
                  </ConditionalBlock>
                </div>
                <div className="flex-right ">
                  <div>
                    {showAddNewButton ? 
                    <button
                      className="btn"
                      onClick={() => navigate("/settings/create-review-workflow")}
                    >
                      Add New
                    </button>
                     : null
                    }
                    
                  </div>
                  
                </div>
              </div>
              <div className="white-bg">
                <div className="integration-tab-content">
                  <div
                    className={
                      active
                        ? "integration-accordion-list open"
                        : "integration-accordion-list"
                    }
                  >
                    <div className="accordion-heading flex"
                         onClick={() => showActive(!active)}>
                      <div className="left">
                        <strong>{departActive()?"Enabled":"Active"} Workflow Templates </strong>
                      </div>
                      <div className="right" onKeyDown={(e) => enabledWorkflowKeydown(e)} tabIndex="0">
                        {PlusCircleIcon}
                        {MinusCircleIcon}
                      </div>
                    </div>
                    <div className="integration-accordion-content flex">
                      <ConditionalBlock condition={deactivateError !== ''} > 
                      <p className="error">{Constants.DEACTIVATE_LAST_WORKFLOW}</p> 
                      </ConditionalBlock> 
                    <ConditionalBlock condition={options.features !== undefined && departActive()}>
                     <p className="w-100">
                        The following workflow templates are available to their
                        respective departments.
                      </p>
                      </ConditionalBlock>
                      <div className="table-responsive global-table">
                        <table className="sortable">
                          <thead>
                            <tr>
                              <th style={{ width: "15%" }}>Name</th>
                              <th style={{ width: "36%" }}>Description</th>
                              <ConditionalBlock condition={options.features !== undefined && departActive()}>
                              <th style={{ width: "36%" }}>Departments</th>
                              </ConditionalBlock>
                              <th style={{ width: "13%" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ConditionalBlock condition={activeWorkflow && activeWorkflow?.length > 0}>
                            {activeWorkflow.map((active, index) => {
                              return (
                                <tr key={index}>
                                  <td><button style={{textAlign:"left"}} onClick={()=>redirect(active)}>{active.name}</button></td>
                                  <td>{active.description}</td>
                                <ConditionalBlock condition={options.features !== undefined && departActive()}>
                                  <td>
                                    {active?.userGroups && active?.userGroups?.length > 0 && active?.userGroups?.map((departs, index) => {
                                      if (
                                        active.userGroups.length ===
                                        index + 1
                                      ) {
                                        return (
                                          <span key={index}>
                                            {" "}
                                            {departs.name}{" "}
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={index}>
                                            {departs.name},{" "}
                                          </span>
                                        );
                                      }
                                    })}
                                  </td>
                                  </ConditionalBlock>
                                  <td>
                                  <ConditionalBlock condition={options.features !== undefined && !departActive()}>
                                     <button
                                     className="inline-flex"
                                     aria-label="delete"
                                     onClick={() => editWorkflowStatus(active.id,active.name,'INACTIVE')}
                                   >
                                     {DeactivateIconWorkflow}
                                   </button>
                                   </ConditionalBlock>
                                   {" "}&nbsp;
                                  <ConditionalBlock condition={active.workflowType.code === "custom" }>
                                      <button
                                        className="inline-flex"
                                        aria-label="delete"
                                        onClick={() => confirmDelete(active.id)}
                                      >
                                        {DeleteIconBold}
                                      </button>
                                       </ConditionalBlock>
                                      {" "}&nbsp;
                                     <ConditionalBlock condition={departActive() || active.workflowType.code == "custom"}>
                                      <button
                                      className="mr-15  inline-flex"
                                      aria-label="edit"
                                      onClick={() => redirect(active)}
                                    >
                                      {EditIconBold}
                                    </button>
                                    </ConditionalBlock>
                                  </td>
                                </tr>
                              );
                            })}
                            </ConditionalBlock>
                          </tbody>
                        </table>
                      </div>
                      
                    </div>
                  </div>
                  <div
                    className={
                      inactive
                        ? "integration-accordion-list open"
                        : "integration-accordion-list"
                    }
                  >
                    <div className="accordion-heading flex" onClick={() => showInActive(!inactive)}>
                      <div className="left">
                        <strong>{!departActive()?"Inactive":"Disabled"} Workflow Templates</strong>
                      </div>
                      <div
                        className="right"
                        onKeyDown={(e) => disabledWorkflowKeydown(e)}
                        tabIndex="0"
                      >
                        <svg
                          className="plus-circle"
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <circle
                            cx="13"
                            cy="13"
                            r="12.3"
                            fill="#F9FBFF"
                            stroke="#1D4ED8"
                            strokeWidth="1.4"
                          />
                          <rect
                            x="12.2773"
                            y="6.5"
                            width="1.44444"
                            height="13"
                            rx="0.722222"
                            fill="#1D4ED8"
                          />
                          <rect
                            x="6.5"
                            y="13.7227"
                            width="1.44444"
                            height="13"
                            rx="0.722222"
                            transform="rotate(-90 6.5 13.7227)"
                            fill="#1D4ED8"
                          />
                        </svg>
                        <svg
                          className="minus-circle"
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <circle
                            cx="13"
                            cy="13"
                            r="12.3"
                            fill="#F9FBFF"
                            stroke="#1D4ED8"
                            strokeWidth="1.4"
                          />
                          <rect
                            x="6.5"
                            y="13.7227"
                            width="1.44444"
                            height="13"
                            rx="0.722222"
                            transform="rotate(-90 6.5 13.7227)"
                            fill="#1D4ED8"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content flex">
                    <ConditionalBlock condition={options.features !== undefined && departActive()}>
                    <p>The following workflow templates are not available to any departments.</p>
                      </ConditionalBlock>
                      {inactiveWorkflow.length !== 0 ? (
                        <div className="table-responsive global-table">
                          <table className="sortable">
                            <thead>
                              <tr>
                                <th style={{ width: "15%" }}>Name</th>
                                <th style={{ width: "36%" }}>Description</th>
                                <ConditionalBlock condition={options.features !== undefined && departActive()}>
                                <th style={{ width: "36%" }}>Departments</th>
                                </ConditionalBlock>
                                <th style={{ width: "13%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {inactiveWorkflow && inactiveWorkflow?.length > 0 &&  inactiveWorkflow.map((inactive, index) => {
                                return (
                                  <tr key={index}>
                                    <td><button 
                                    onClick={() =>
                                      redirectInactive(inactive)
                                    }
                                    style={{textAlign:"left"}} >{inactive.name}</button></td>
                                    <td>{inactive.description}</td>
                                <ConditionalBlock  condition={options.features !== undefined && departActive()}>
                                    <td>
                                      {inactive?.userGroups && inactive?.userGroups?.length > 0 && inactive?.userGroups.map(
                                        (departs, index) => {
                                          if (
                                            inactive.userGroups.length ===
                                            index + 1
                                          ) {
                                            return (
                                              <span key={index}>
                                                {" "}
                                                {departs.name}{" "}
                                              </span>
                                            );
                                          } else {
                                            return (
                                              <span key={index}>
                                                {departs.name},{" "}
                                              </span>
                                            );
                                          }
                                        }
                                      )}
                                    </td>
                                    </ConditionalBlock>
                                    <td>
                                    <ConditionalBlock condition={options.features !== undefined && departActive()}>
                                      <button
                                        className="inline-flex"
                                        aria-label="edit"
                                        onClick={() =>
                                          redirectInactive(inactive)
                                        }
                                      >
                                        <svg
                                          className="aaa-change-icon"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="19"
                                          viewBox="0 0 17 19"
                                          fill="none"
                                        >
                                          <path
                                            d="M15.2521 4.97331C15.6144 4.61106 15.8137 4.12997 15.8137 3.61822C15.8137 3.10647 15.6144 2.62539 15.2521 2.26314L13.7322 0.743224C13.3699 0.380974 12.8889 0.181641 12.3771 0.181641C11.8654 0.181641 11.3843 0.380974 11.023 0.742266L0.833984 10.8996V15.1307H5.06311L15.2521 4.97331ZM12.3771 2.09831L13.898 3.61727L12.3742 5.13526L10.8543 3.61631L12.3771 2.09831ZM2.75065 13.214V11.6951L9.49732 4.96947L11.0172 6.48939L4.27153 13.214H2.75065ZM0.833984 17.0473H16.1673V18.964H0.833984V17.0473Z"
                                            fill="#1D4ED8"
                                          />
                                        </svg>
                                      </button> 
                                      </ConditionalBlock>
                                      <ConditionalBlock condition={options.features !== undefined && !departActive()}>
                                      <button
                                      className="inline-flex"
                                      aria-label="edit"
                                      onClick={() =>
                                        editWorkflowStatus(inactive.id,inactive.name,'ACTIVE')
                                      }
                                    >
                                      {ActivateIconWorkflow}
                                    </button>
                                    </ConditionalBlock>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          className="no-data-display align-center w-d100"
                          style={{ marginTop: "25px" }}
                        >
                          <i className="nodata-icon"></i>
                          <p>{Constants.NO_DATA_FOUND}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
